function MinimalProductArea(
	el_product_pictures,
	el_thumbnails,
	el_button_prev,
	el_button_next,
	options
) {
	let active_index = 0;
	let item_count = el_thumbnails.children.length;

	function reposition() {
		el_thumbnails.scrollTop = 0;
		// Get width of container
		let container_w = el_thumbnails.clientWidth;
		// Get width of the thumbnail
		let thumbnail_w = el_thumbnails.children[0].clientWidth;
		// Get position of active thumbnail
		let active_y = el_thumbnails.children[active_index].offsetLeft;
		let scroll_position = el_thumbnails.scrollLeft;
		// Test if active thumbnail outside of visible area of contain reposition scroll point
		//		Reposition scroll position

		// If falling off the left edge.
		if (active_y < scroll_position) {
			el_thumbnails.scrollLeft = active_y;
		}

		// If falling off the right edge
		if (scroll_position + container_w < active_y + thumbnail_w) {
			el_thumbnails.scrollLeft = active_y + thumbnail_w - container_w;
		}

		set_thumbnail_class();
	}

	function activation_buttons_scroll() {
		// If hide buttons option set hide/show the scroll buttons
		let container_w = el_thumbnails.clientWidth;
		let viewport_width = el_thumbnails.scrollWidth;
		let scroll_position = el_thumbnails.scrollLeft;
		if (scroll_position == 0) {
			el_button_prev.style.opacity = 0;
		}
		else {
			el_button_prev.style.opacity = 1;
		}
		if (scroll_position >= viewport_width - container_w) {
			el_button_next.style.opacity = 0;
		}
		else {
			el_button_next.style.opacity = 1;
		}
	}

	function activation_buttons() {
		if (active_index == 0) {
			el_button_prev.style.opacity = 0;
		}
		else {
			el_button_prev.style.opacity = 1;
		}
		if (active_index == item_count - 1) {
			el_button_next.style.opacity = 0;
		}
		else {
			el_button_next.style.opacity = 1;
		}
	}

	function set_product_image() {
		for (var i = 0; i < el_product_pictures.children.length; i++) {
			el_product_pictures.children[i].style.opacity = 0;
			el_product_pictures.children[i].style['z-index'] = 0;
		}
		el_product_pictures.children[active_index].style.opacity = 1;
		el_product_pictures.children[active_index].style['z-index'] = 1;
	}

	function next_item_clicked() {
		if (active_index + 1 < item_count) {
			active_index += 1;
			reposition();
			set_product_image();
			if (hide_buttons) activation_buttons();
		}
	}

	function prev_item_clicked() {
		if (active_index - 1 >= 0) {
			active_index -= 1;
			reposition();
			set_product_image();
			if (hide_buttons) activation_buttons();
		}
	}

	function thumbnail_clicked(e) {
		active_index = parseInt(e.currentTarget.dataset.index);
		reposition();
		if (hide_buttons) activation_buttons();
		set_product_image();
	}

	function scroll_changed(e) {
		if (hide_buttons) activation_buttons_scroll();
	}

	function set_thumbnail_class() {
		// Clear and set classes
		for (let i = 0; i < el_thumbnails.children.length; i++) {
			el_thumbnails.children[i].classList.remove(active_class);
		}
		el_thumbnails.children[active_index].classList.add(active_class);
	}

	// Set any needed defaults
	let active_class = "thumbnail-active";
	if (options.hasOwnProperty('active_class')) {
		active_class = options.active_class;
	}
	let hide_buttons = true;
	if (options.hasOwnProperty('hide_buttons')) {
		hide_buttons = options.hide_buttons;
	}

	// Connect event handlers
	el_button_prev.addEventListener('click', prev_item_clicked);
	el_button_next.addEventListener('click', next_item_clicked);
	el_thumbnails.addEventListener('scroll', scroll_changed);

	for (let i = 0; i < el_thumbnails.children.length; i++) {
		el_thumbnails.children[i].addEventListener('click', thumbnail_clicked);
	}

	el_thumbnails.children[0].classList.add(active_class);
	if (hide_buttons) {
		el_button_prev.style.opacity = 0;
	}

	set_product_image();

	if (typeof SwpieDetect === "function") {
		SwpieDetect(
			el_product_pictures,
			next_item_clicked,
			prev_item_clicked,
			next_item_clicked,
			prev_item_clicked
		);
	}

	if (typeof DragToScroll === "function") {
			DragToScroll(el_thumbnails, false, false, true);
	}

	return this;
}
